import { replaceUrl } from 'utils/helpers/replaceUrl';

import { PaymentMethod, usePaymentMethodsQuery } from '@/graphql/paymentMethods';

let hasSetInitialPaymentMethod = false;

export function usePaymentMethod() {
  const { data } = usePaymentMethodsQuery();
  const paymentMethod = data?.paymentMethods?.data?.find(pm => pm.id === getPaymentMethodId());

  if (data?.paymentMethods?.data && !hasSetInitialPaymentMethod) {
    hasSetInitialPaymentMethod = true;
    void setInitialPaymentMethod(data.paymentMethods.data);
  }

  return {
    getPaymentMethod,
    getPaymentMethodId,
    paymentMethodType: paymentMethod?.paymentMethodType,
    setPaymentMethod,
  };
}

export function getPaymentMethod() {
  if (typeof window === 'undefined') {
    return null;
  }
  const paymentMethod = new URLSearchParams(location.search).get('payment_method');
  if (paymentMethod === 'paymentrequest') {
    return 'paymentRequest';
  }
  return paymentMethod;
}

export function getPaymentMethodId() {
  const paymentMethod = getPaymentMethod();
  if (paymentMethod) {
    return parseInt(paymentMethod);
  }
}

async function setPaymentMethod(paymentMethod?: string | number) {
  await replaceUrl({
    payment_method: paymentMethod,
  });
}

async function setInitialPaymentMethod(paymentMethods: Array<PaymentMethod>) {
  const paymentMethod = paymentMethods.find(pm => pm.default) ?? paymentMethods[0];
  await setPaymentMethod(paymentMethod.id);
}
